import React from "react";
import { makeStyles } from "@material-ui/core";
import LabeledContent from "../../../../components/LabeledContent";

const useStyles = makeStyles(() => ({
  labeledContent: {
    "& > :first-child": {
      fontSize: 14,
      color: " #828190",
    },
    "& > :last-child": {
      fontSize: 14,
      color: " #535358",
    },
  },
  tuitionContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    minHeight: 74,
  },
}));

export const FinanceViewSecondary = ({
  tuition,
  commission,
  otherFees,
  scholarship,
  financialAid,
  boardingAmount,
  homestayAmount,
  insuranceAmount,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.tuitionContainer}>
      <LabeledContent className={classes.labeledContent} label={"Tuition"}>
        {tuition}
      </LabeledContent>
      <LabeledContent className={classes.labeledContent} label={"Commission"}>
        {commission}
      </LabeledContent>

      <LabeledContent
        className={classes.labeledContent}
        label={"Room and Board"}
      >
        {boardingAmount}
      </LabeledContent>
      <LabeledContent className={classes.labeledContent} label={"Homestay"}>
        {homestayAmount}
      </LabeledContent>
      <LabeledContent className={classes.labeledContent} label={"Insurance"}>
        {insuranceAmount}
      </LabeledContent>

      <LabeledContent className={classes.labeledContent} label={"Other Fees"}>
        {otherFees}
      </LabeledContent>
      <LabeledContent className={classes.labeledContent} label={"Scholarship"}>
        {scholarship}
      </LabeledContent>
      <LabeledContent
        className={classes.labeledContent}
        label={"Financial Aid"}
      >
        {financialAid}
      </LabeledContent>
    </div>
  );
};
